module.exports = __webpack_public_path__ + "static/img/code-icon1.43f5dfb.png";


//////////////////
// WEBPACK FOOTER
// ./static/popup/code-icon1.png
// module id = CHSb
// module chunks = 1